import "./App.css";
import { Route, Routes } from "react-router-dom";
import Main from "./pages/main/Main";
import ProgressContext from "./utils/context";
import { useState } from "react";

function App() {
  const [progess, setProgress] = useState();

  const updateProgress = (value) => {
    setProgress(value);
  };

  return (
    <ProgressContext.Provider value={{ progess, updateProgress }}>
      <Routes>
        <Route path="/" element={<Main />} />
      </Routes>
    </ProgressContext.Provider>
  );
}

export default App;
